import { useQuery } from '@tanstack/react-query'
import type { RoomCountOutput } from 'types/api'
import { apiClient } from '../api-client'
import { SNA_PREFIX } from '@services/utils'

export const roomsQueryKey = ['rooms']

export function useRooms() {
  async function getRooms() {
    const response = await apiClient.get<RoomCountOutput[]>(
      SNA_PREFIX + `room-counts`
    )

    return response.data
  }

  return useQuery({
    queryFn: getRooms,
    queryKey: [...roomsQueryKey]
  })
}
